import React, { useEffect, useMemo, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CreateCollectionModal from "./CreateCollectionModal";
import { collectionlistAction } from "../Redux/Action/collectionAction";
import { useDispatch, useSelector } from "react-redux";
import SearchBar from "../Components/common/SearchBar";
import LoaderComponent from "../Components/common/LoaderComponent";
import { toast } from "react-hot-toast";
import { browseAddToCollectionAction } from "../Redux/Action/browseAction";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  studentDetailAction,
  studentShareCollectionAction,
} from "../Redux/Action/studentAction";
import {
  AddCollectionToclassAction,
  classdetailsAction,
} from "../Redux/Action/classAction";
import moment from "moment";
import { useLocation } from "react-router-dom";
import ConfirmModal from "./ConfirmModal";
import { getGroupFromYear } from "../Util/HelperFunction";

const SaveToCollection = ({
  show,
  handleClose,
  selectedSave,
  type,
  shortContainerRef,
}) => {
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const groupString = queryParams.get("groups"); // e.g., "3,4,14"
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [value, setValue] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);

  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(" ");

  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showCollection, setShowCollection] = useState(false);

  const studentDetail = useSelector(
    (state) => state?.studentSlice?.studentDetail
  );
  const classDetails = useSelector(
    (state) => state?.classSlice?.classDetails
  );

  const handleCloseCollection = () => {
    setShowCollection(false);
  };

  const handleShowCollection = () => setShowCollection(true);
  const FilterPayload = {
    searchValue: searchValue,
  };

  useEffect(() => {
    setIsLoading(true);
    dispatch(collectionlistAction(FilterPayload)).finally(() => {
      setIsLoading(false);
    });
  }, [searchValue, showCollection]);

  const collectionListData = useSelector(
    (state) => state?.collectionSlice?.collectionData
  );

  const selectedCollections = useMemo(() => {
    if (!Array.isArray(collectionListData)) return [];
    return collectionListData.filter((col) => selectedItems.includes(col._id));
  }, [collectionListData, selectedItems]);

  const allSelectedVideos = useMemo(() => {
    return selectedCollections.flatMap((col) =>
      Array.isArray(col?.video) ? col.video : []
    );
  }, [selectedCollections]);

  const getVideoGroups = (video) => {
    const raw = video?.group || video?.videoId?.group || video?.groups;
    if (Array.isArray(raw)) {
      return raw.map(Number).filter(Number.isFinite);
    }
    if (typeof raw === "string" && raw.includes(",")) {
      return raw.split(",").map(Number).filter(Number.isFinite);
    }
    if (raw !== undefined && raw !== null && raw !== "") {
      const num = Number(raw);
      if (Number.isFinite(num)) return [num];
    }
    return [];
  };

  const getTargetLearnerGroups = () => {
    const groups = [];
    if (
      studentDetail?.group !== undefined &&
      studentDetail?.group !== null &&
      studentDetail?.group !== ""
    ) {
      const g = Number(studentDetail.group);
      if (Number.isFinite(g)) groups.push(g);
    }
    if (studentDetail?.year) {
      const g = getGroupFromYear(studentDetail.year);
      if (g !== "" && Number.isFinite(Number(g))) groups.push(Number(g));
    }
    if (studentDetail?.classId?.group) {
      const g = Number(studentDetail.classId.group);
      if (Number.isFinite(g)) groups.push(g);
    }
    if (groupString && groupString.trim() !== "") {
      const urlG = groupString.split(",").map(Number).filter(Number.isFinite);
      groups.push(...urlG);
    }
    return [...new Set(groups)];
  };

  const getTargetClassGroups = () => {
    const groups = [];
    if (
      classDetails?.group !== undefined &&
      classDetails?.group !== null &&
      classDetails?.group !== ""
    ) {
      const g = Number(classDetails.group);
      if (Number.isFinite(g)) groups.push(g);
    }
    if (classDetails?.year) {
      const g = getGroupFromYear(classDetails.year);
      if (g !== "" && Number.isFinite(Number(g))) groups.push(Number(g));
    }
    if (groupString && groupString.trim() !== "") {
      const urlG = groupString.split(",").map(Number).filter(Number.isFinite);
      groups.push(...urlG);
    }
    return [...new Set(groups)];
  };

  const handleSave = async (ele) => {
    setLoading(true);
    const payload = {
      id: selectedSave,
      collectionId: selectedItems,
    };
    try {
      const res = await dispatch(browseAddToCollectionAction(payload));
      if (res?.payload?.statusCode == 200) {
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
        dispatch(collectionlistAction(FilterPayload));
        setLoading(false);
        handleClose();
        setSelectedItems([]);
      } else {
        if (Array.isArray(selectedItems) && selectedItems?.length === 0) {
          toast.error("Collection is required");
          setLoading(false);
        } else {
          toast.error(res?.payload?.message);
          setLoading(false);
        }
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

















  const handleShare = async (ele) => {
    const targetGroups = getTargetLearnerGroups();

    let hasMismatch = false;

    if (allSelectedVideos.length > 0 && targetGroups.length > 0) {
      hasMismatch = targetGroups.some((targetGroup) => {
        return allSelectedVideos.some((video) => {
          const vGroups = getVideoGroups(video);
          return vGroups.length > 0 && !vGroups.includes(targetGroup);
        });
      });
    } else if (selectedGroups.length > 0 && targetGroups.length > 0) {
      hasMismatch = targetGroups.some((tg) => !selectedGroups.includes(tg));
    }

    if (hasMismatch) {
      setSelectedType("sensitiveContent");
      setModalOpen(true);
    } else {
      sensitiveContentShare();
    }
  };

  const sensitiveContentShare = async () => {
    setLoading(true);
    const payload = {
      studentId: selectedSave,
      collection: selectedItems,
    };
    try {
      const res = await dispatch(studentShareCollectionAction(payload));
      if (res?.payload?.statusCode == 200) {
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
        setLoading(false);
        dispatch(studentDetailAction(selectedSave));
        handleClose();
        setSelectedItems([]);
        handleConfirmClose();
        setSelectedGroups([]);
      } else {
        if (Array.isArray(selectedItems) && selectedItems?.length === 0) {
          toast.error("Collection is required");
          setLoading(false);
        } else {
          toast.error(res?.payload?.message);
          setLoading(false);
        }
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const handleShareCollectionWithClass = async (ele) => {
    const targetGroups = getTargetClassGroups();

    let hasMismatch = false;

    if (allSelectedVideos.length > 0 && targetGroups.length > 0) {
      hasMismatch = targetGroups.some((targetGroup) => {
        return allSelectedVideos.some((video) => {
          const vGroups = getVideoGroups(video);
          return vGroups.length > 0 && !vGroups.includes(targetGroup);
        });
      });
    } else if (selectedGroups.length > 0 && targetGroups.length > 0) {
      hasMismatch = targetGroups.some((tg) => !selectedGroups.includes(tg));
    }

    if (hasMismatch) {
      setSelectedType("sensitiveContent");
      setModalOpen(true);
    } else {
      sensitiveContentAdd();
    }
  };

  const sensitiveContentAdd = async () => {
    setLoading(true);
    const payload = {
      class: selectedSave,
      collection: selectedItems,
    };
    try {
      const res = await dispatch(AddCollectionToclassAction(payload));
      if (res?.payload?.statusCode == 200) {
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
        setLoading(false);
        dispatch(classdetailsAction(selectedSave));
        handleClose();
        setSelectedItems([]);
        handleConfirmClose();
        setSelectedGroups([]);
      } else {
        if (Array.isArray(selectedItems) && selectedItems?.length === 0) {
          toast.error("Collection is required");
          setLoading(false);
        } else {
          toast.error(res?.payload?.message);
          setLoading(false);
        }
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    }
  };

  const tooltipText =
    "This Collection is private. Change its Privacy Setting if you want to share it with others";

  const renderText = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      <span
        style={{
          fontFamily: "Raleway, sans-serif",
          fontSize: "14px",
          color: "#333",
          display: "inline-block",
        }}
      >
        {tooltipText}
      </span>
    </Tooltip>
  );

  const handleChoose = (item) => {
    if (selectedItems.includes(item._id)) {
      const nextSelected = selectedItems.filter(
        (selectedKey) => selectedKey !== item._id
      );
      setSelectedItems(nextSelected);

      const remainingCollections = (collectionListData || []).filter((col) =>
        nextSelected.includes(col._id)
      );
      const remainingGroups = [
        ...new Set(
          remainingCollections
            .flatMap((col) => (Array.isArray(col?.video) ? col.video : []))
            .flatMap((video) => getVideoGroups(video))
        ),
      ];
      setSelectedGroups(remainingGroups);
    } else {
      setSelectedItems([...selectedItems, item._id]);

      const groupsFromVideos = (Array.isArray(item?.video) ? item.video : []).flatMap(
        (video) => getVideoGroups(video)
      );
      setSelectedGroups((prev) => [...new Set([...prev, ...groupsFromVideos])]);
    }
  };

  const handleConfirmClose = async () => {
    setModalOpen(false);
  };

  return (
    <>
      <Modal
        size="lg"
        show={show && !showCollection}
        onHide={handleClose}
        className="comn-modal-set"
        container={shortContainerRef?.current}
      >
        <Modal.Header className="d-block" style={{ border: "0" }}>
          <Row>
            <Col lg={12} md={12} className="d-flex justify-content-center mb-2">
              <div className="text-center w-100">
                {type === "StudentDetail" && (
                  <>
                    <Modal.Title>Share Collection</Modal.Title>
                    <p className="text-center mb-0">
                      Share collection with student
                    </p>
                  </>
                )}

                {type === "PlayBack" && (
                  <>
                    <Modal.Title>Save Video to Collection</Modal.Title>
                    <p className="text-center mb-3 mt-1" style={{ color: "#555", fontSize: "14px" }}>
                      Create a new Collection, or save the video to existing Collection(s)
                    </p>
                    <div className="d-flex justify-content-center align-items-center gap-3">
                      <button
                        type="button"
                        className="cmn-yellow"
                        onClick={handleShowCollection}
                        style={{
                          width: "auto",
                          maxWidth: "none",
                          padding: "8px 22px",
                          borderRadius: "37px",
                          fontSize: "14px",
                          fontWeight: "600",
                          whiteSpace: "nowrap",
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        Create New Collection
                      </button>
                      {selectedItems?.length === 0 ? (
                        <OverlayTrigger
                          placement="bottom"
                          overlay={
                            <Tooltip id="save-collection-tooltip">
                              Please select a collection first
                            </Tooltip>
                          }
                        >
                          <span
                            className="d-inline-block"
                            tabIndex="0"
                            style={{ cursor: "not-allowed" }}
                          >
                            <button
                              type="button"
                              disabled
                              style={{
                                width: "auto",
                                maxWidth: "none",
                                minWidth: "unset",
                                padding: "8px 24px",
                                borderRadius: "37px",
                                fontSize: "14px",
                                fontWeight: "600",
                                whiteSpace: "nowrap",
                                margin: 0,
                                background: "#8073a4",
                                backgroundColor: "#8073a4",
                                color: "#ffffff",
                                border: "none",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                pointerEvents: "none",
                              }}
                            >
                              Save to Collection
                            </button>
                          </span>
                        </OverlayTrigger>
                      ) : (
                        <button
                          type="button"
                          className="modal-f-btn"
                          onClick={handleSave}
                          disabled={loading}
                          style={{
                            width: "auto",
                            maxWidth: "none",
                            minWidth: "unset",
                            padding: "8px 24px",
                            borderRadius: "37px",
                            fontSize: "14px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                            margin: 0,
                            cursor: loading ? "not-allowed" : "pointer",
                            backgroundColor: "var(--accent-pink)",
                            color: "#ffffff",
                            opacity: 1,
                            border: "none",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.2s ease-in-out",
                          }}
                        >
                          {loading ? "loading..." : "Save to Collection"}
                        </button>
                      )}
                    </div>
                  </>
                )}

                {type === "CollectionAddToTheClass" && (
                  <>
                    <Modal.Title>Add Collection</Modal.Title>
                    <p className="text-center mb-0">
                      Share collection with this class
                    </p>
                  </>
                )}
              </div>
            </Col>
          </Row>
          <div className="modal-right">
            {type !== "PlayBack" && (
              <button className="cmn-yellow" onClick={handleShowCollection}>
                Create New Collection
              </button>
            )}
            <button className="menu-dots" onClick={handleClose}>
              <img src={require("../Assets/Images/dotsweb.svg").default} alt="Menu options" />
            </button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <Row className="justify-content-center">
              <Col lg={8}>
                <div className="user-pro-search">
                  <SearchBar setSearchValue={setSearchValue} />
                </div>
              </Col>
            </Row>
            <Row className="cards-execceded">
              {isLoading ? (
                <LoaderComponent />
              ) : collectionListData &&
                collectionListData?.collection &&
                collectionListData?.collection.length > 0 ? (
                <>
                  {type === "PlayBack" ? (
                    <>
                      {collectionListData.collection.map((ele, index) => {
                        if (
                          type === "StudentDetail" &&
                          ele?.accessType === "PRIVATE"
                        )
                          return null;
                        if (
                          type === "CollectionAddToTheClass" &&
                          ele?.accessType === "PRIVATE"
                        )
                          return null;
                        return (
                          <Col lg={6} className="mt-4" key={index}>
                            <div
                              onClick={() => handleChoose(ele)}
                              className={
                                selectedItems.includes(ele._id)
                                  ? "collection-video-inner active-box "
                                  : "collection-video-inner"
                              }
                            >
                              <Row style={{ cursor: "pointer" }}>
                                <Col lg={3} md={3} sm={3}>
                                  <img
                                    src={
                                      ele?.image
                                        ? ele?.image
                                        : require("../Assets/Images/clogo.png")
                                    }
                                  />
                                </Col>
                                <Col
                                  lg={6}
                                  md={6}
                                  sm={6}
                                  className="d-flex align-items-start collectons-section"
                                >
                                  <div className="test-collection-desc">
                                    <h3>{ele.name}</h3>

                                    <p
                                      style={{
                                        fontSize: "14px",
                                        color: "#2B3674",
                                        margin: "0 0 5px 0",
                                        lineHeight: "18px",
                                      }}
                                    >
                                      Created by:{" "}
                                      <>
                                        {ele?.createdBy === "Teacher" && (
                                          <>
                                            {ele?.teacherId?.firstName}{" "}
                                            {ele?.teacherId?.surName}
                                          </>
                                        )}

                                        {ele?.createdBy === "School" && (
                                          <>{ele?.schoolId?.schoolName}</>
                                        )}

                                        {ele?.createdBy === "SchoolAdmin" && (
                                          <>
                                            {ele?.schoolAdminId?.firstName}{" "}
                                            {ele?.schoolAdminId?.surName}
                                          </>
                                        )}
                                        {ele?.createdBy === "Student" && (
                                          <>
                                            {ele?.studentId?.name}
                                            {ele?.studentId?.firstName}{" "}
                                            {ele?.studentId?.surName}
                                          </>
                                        )}
                                      </>
                                    </p>

                                    <p>
                                      Shared with{" "}
                                      {ele?.sharedWithStudentsCount ?? 0}{" "}
                                      student
                                      {ele?.sharedWithStudentsCount === 1
                                        ? ""
                                        : "s"}
                                    </p>
                                    <p>
                                      Shared with{" "}
                                      {ele?.sharedWithTeachersOrAdminsCount ??
                                        0}{" "}
                                      teacher
                                      {ele?.sharedWithTeachersOrAdminsCount ===
                                      1
                                        ? ""
                                        : "s"}
                                    </p>
                                  </div>
                                  <p>
                                    Created on{" "}
                                    {ele?.createdAt
                                      ? moment(ele?.createdAt).format(
                                          "DD/MM/YYYY"
                                        )
                                      : null}
                                  </p>
                                </Col>
                                <Col
                                  lg={3}
                                  md={3}
                                  sm={3}
                                  xs={3}
                                  className="video-count-main"
                                >
                                  <div className="videos-counting-sec">
                                    <p className="text-end">
                                      {Array.isArray(ele?.video) &&
                                      ele?.video.length > 0
                                        ? ele?.video?.length
                                        : 0}{" "}
                                      videos
                                    </p>
                                  </div>

                                  <div className="security-sec d-flex gap-2 ">
                                    {ele?.accessType == "PUBLIC" && (
                                      <>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="11"
                                          height="14"
                                          viewBox="0 0 11 14"
                                          fill="none"
                                        >
                                          <rect
                                            x="1"
                                            y="5.6152"
                                            width="9.23077"
                                            height="7.38474"
                                            rx="1"
                                            stroke="#201A46"
                                            strokeWidth="0.8"
                                            stroke-linejoin="round"
                                          />
                                          <rect
                                            x="4.75"
                                            y="8.50015"
                                            width="1.49944"
                                            height="1.49946"
                                            rx="0.74972"
                                            stroke="#201A46"
                                            strokeWidth="0.8"
                                            stroke-linejoin="round"
                                          />
                                          <path
                                            d="M7.92398 2.97805V2.97805C7.92398 1.88561 7.03838 1 5.94593 1H5.61629C4.34178 1 3.30859 2.03319 3.30859 3.30769V5.61546H5.61629"
                                            stroke="#201A46"
                                            strokeWidth="0.8"
                                            stroke-linejoin="round"
                                          />
                                        </svg>
                                        <p>Public</p>
                                      </>
                                    )}
                                    {ele?.accessType == "PRIVATE_GROUP" && (
                                      <>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <circle
                                            cx="9.5"
                                            cy="12.5"
                                            r="2.5"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M14 19.75C14 21.8211 11.5711 22 9.5 22C7.42893 22 5 21.8211 5 19.75C5 17.6789 7.42893 16 9.5 16C11.5711 16 14 17.6789 14 19.75Z"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M13.5527 14.7711C14.6631 14.7711 15.5633 13.8709 15.5633 12.7605C15.5633 11.6501 14.6631 10.75 13.5527 10.75"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M16.5685 18.9999C16.5685 17.2252 15.2379 15.6654 13.5527 14.771"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M5.01562 14.7711C3.90524 14.7711 3.00509 13.8709 3.00509 12.7605C3.00509 11.6501 3.90524 10.75 5.01562 10.75"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            stroke-linecap="round"
                                          />
                                          <path
                                            d="M1.99982 18.9999C1.99982 17.2252 3.33042 15.6654 5.01562 14.771"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            stroke-linecap="round"
                                          />
                                          <rect
                                            x="15"
                                            y="4.15356"
                                            width="6.30769"
                                            height="5.04615"
                                            rx="1"
                                            stroke="#99A1BB"
                                            stroke-linejoin="round"
                                          />
                                          <rect
                                            x="17.5625"
                                            y="6.125"
                                            width="1.025"
                                            height="1.025"
                                            rx="0.5125"
                                            stroke="#99A1BB"
                                            stroke-linejoin="round"
                                          />
                                          <path
                                            d="M16.5781 2.57692C16.5781 1.70601 17.2841 1 18.155 1V1C19.026 1 19.732 1.70601 19.732 2.57692V4.15385H18.155H16.5781V2.57692Z"
                                            stroke="#99A1BB"
                                            stroke-linejoin="round"
                                          />
                                        </svg>
                                        <p>Share Only</p>
                                      </>
                                    )}
                                    {ele?.accessType == "PRIVATE" && (
                                      <>
                                        <svg
                                          className="private"
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="20"
                                          viewBox="0 0 16 20"
                                          fill="none"
                                        >
                                          <rect
                                            x="1"
                                            y="8"
                                            width="14"
                                            height="11.2"
                                            rx="1"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            stroke-linejoin="round"
                                          />
                                          <rect
                                            x="6.6875"
                                            y="12.375"
                                            width="2.275"
                                            height="2.275"
                                            rx="1.1375"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            stroke-linejoin="round"
                                          />
                                          <path
                                            d="M4.5 4.5C4.5 2.567 6.067 1 8 1V1C9.933 1 11.5 2.567 11.5 4.5V8H8H4.5V4.5Z"
                                            stroke="#99A1BB"
                                            strokeWidth="1.5"
                                            stroke-linejoin="round"
                                          />
                                        </svg>
                                        <p>Private</p>
                                      </>
                                    )}
                                  </div>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                        );
                      })}
                    </>
                  ) : (
                    <>
                      {collectionListData.collection.map((ele, index) => {
                        if (
                          type === "StudentDetail" &&
                          ele?.accessType === "PRIVATE"
                        )
                          return null;

                        return (
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              ele?.accessType === "PRIVATE" ? renderText : <></>
                            }
                          >
                            <Col lg={6} className="mt-4 " key={index}>
                              <div
                                onClick={() =>
                                  ele?.accessType === "PRIVATE"
                                    ? null
                                    : handleChoose(ele)
                                }
                                className={
                                  selectedItems.includes(ele._id)
                                    ? `collection-video-inner ${
                                        ele?.accessType === "PRIVATE"
                                          ? ""
                                          : "active-box"
                                      }`
                                    : "collection-video-inner"
                                }
                              >
                                <Row
                                  style={{ cursor: "pointer" }}
                                  className={
                                    ele?.accessType === "PRIVATE"
                                      ? "private-disable"
                                      : ""
                                  }
                                >
                                  <Col lg={3} md={3} sm={3}>
                                    <img
                                      src={
                                        ele?.image
                                          ? ele?.image
                                          : require("../Assets/Images/clogo.png")
                                      }
                                    />
                                  </Col>
                                  <Col
                                    lg={6}
                                    md={6}
                                    sm={6}
                                    className="d-flex align-items-start collectons-section"
                                  >
                                    <div className="collections-test">
                                      <div className="test-collection-desc">
                                        <h3>{ele.name}</h3>

                                        <p
                                          style={{
                                            fontSize: "14px",
                                            color: "#2B3674",
                                            margin: "0 0 5px 0",
                                            lineHeight: "18px",
                                          }}
                                        >
                                          Created by:{" "}
                                          <>
                                            {ele?.createdBy === "Teacher" && (
                                              <>
                                                {ele?.teacherId?.firstName}{" "}
                                                {ele?.teacherId?.surName}
                                              </>
                                            )}

                                            {ele?.createdBy === "School" && (
                                              <>{ele?.schoolId?.schoolName}</>
                                            )}

                                            {ele?.createdBy ===
                                              "SchoolAdmin" && (
                                              <>
                                                {ele?.schoolAdminId?.firstName}{" "}
                                                {ele?.schoolAdminId?.surName}
                                              </>
                                            )}
                                            {ele?.createdBy === "Student" && (
                                              <>
                                                {ele?.studentId?.name}
                                                {ele?.studentId?.firstName}{" "}
                                                {ele?.studentId?.surName}
                                              </>
                                            )}
                                          </>
                                        </p>

                                        <p>
                                          Shared with{" "}
                                          {ele?.sharedWithStudentsCount ?? 0}{" "}
                                          student
                                          {ele?.sharedWithStudentsCount === 1
                                            ? ""
                                            : "s"}
                                        </p>
                                        <p>
                                          Shared with{" "}
                                          {ele?.sharedWithTeachersOrAdminsCount ??
                                            0}{" "}
                                          teacher
                                          {ele?.sharedWithTeachersOrAdminsCount ===
                                          1
                                            ? ""
                                            : "s"}
                                        </p>
                                      </div>
                                      <p>
                                        {ele?.createdAt
                                          ? moment(ele?.createdAt).format(
                                              "DD/MM/YYYY"
                                            )
                                          : null}
                                      </p>
                                    </div>
                                  </Col>
                                  <Col
                                    lg={3}
                                    md={3}
                                    sm={3}
                                    xs={3}
                                    className="video-count-main"
                                  >
                                    <div className="videos-counting-sec">
                                      <p className="text-end">
                                        {Array.isArray(ele?.video) &&
                                        ele?.video.length > 0
                                          ? ele?.video?.length
                                          : 0}{" "}
                                        videos
                                      </p>
                                    </div>

                                    <div className="security-sec d-flex gap-2 ">
                                      {ele?.accessType == "PUBLIC" && (
                                        <>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="11"
                                            height="14"
                                            viewBox="0 0 11 14"
                                            fill="none"
                                          >
                                            <rect
                                              x="1"
                                              y="5.6152"
                                              width="9.23077"
                                              height="7.38474"
                                              rx="1"
                                              stroke="#201A46"
                                              strokeWidth="0.8"
                                              stroke-linejoin="round"
                                            />
                                            <rect
                                              x="4.75"
                                              y="8.50015"
                                              width="1.49944"
                                              height="1.49946"
                                              rx="0.74972"
                                              stroke="#201A46"
                                              strokeWidth="0.8"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M7.92398 2.97805V2.97805C7.92398 1.88561 7.03838 1 5.94593 1H5.61629C4.34178 1 3.30859 2.03319 3.30859 3.30769V5.61546H5.61629"
                                              stroke="#201A46"
                                              strokeWidth="0.8"
                                              stroke-linejoin="round"
                                            />
                                          </svg>
                                          <p>Public</p>
                                        </>
                                      )}
                                      {ele?.accessType == "PRIVATE_GROUP" && (
                                        <>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                          >
                                            <circle
                                              cx="9.5"
                                              cy="12.5"
                                              r="2.5"
                                              stroke="#99A1BB"
                                              strokeWidth="1.5"
                                              stroke-linecap="round"
                                            />
                                            <path
                                              d="M14 19.75C14 21.8211 11.5711 22 9.5 22C7.42893 22 5 21.8211 5 19.75C5 17.6789 7.42893 16 9.5 16C11.5711 16 14 17.6789 14 19.75Z"
                                              stroke="#99A1BB"
                                              strokeWidth="1.5"
                                              stroke-linecap="round"
                                            />
                                            <path
                                              d="M13.5527 14.7711C14.6631 14.7711 15.5633 13.8709 15.5633 12.7605C15.5633 11.6501 14.6631 10.75 13.5527 10.75"
                                              stroke="#99A1BB"
                                              strokeWidth="1.5"
                                              stroke-linecap="round"
                                            />
                                            <path
                                              d="M16.5685 18.9999C16.5685 17.2252 15.2379 15.6654 13.5527 14.771"
                                              stroke="#99A1BB"
                                              strokeWidth="1.5"
                                              stroke-linecap="round"
                                            />
                                            <path
                                              d="M5.01562 14.7711C3.90524 14.7711 3.00509 13.8709 3.00509 12.7605C3.00509 11.6501 3.90524 10.75 5.01562 10.75"
                                              stroke="#99A1BB"
                                              strokeWidth="1.5"
                                              stroke-linecap="round"
                                            />
                                            <path
                                              d="M1.99982 18.9999C1.99982 17.2252 3.33042 15.6654 5.01562 14.771"
                                              stroke="#99A1BB"
                                              strokeWidth="1.5"
                                              stroke-linecap="round"
                                            />
                                            <rect
                                              x="15"
                                              y="4.15356"
                                              width="6.30769"
                                              height="5.04615"
                                              rx="1"
                                              stroke="#99A1BB"
                                              stroke-linejoin="round"
                                            />
                                            <rect
                                              x="17.5625"
                                              y="6.125"
                                              width="1.025"
                                              height="1.025"
                                              rx="0.5125"
                                              stroke="#99A1BB"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M16.5781 2.57692C16.5781 1.70601 17.2841 1 18.155 1V1C19.026 1 19.732 1.70601 19.732 2.57692V4.15385H18.155H16.5781V2.57692Z"
                                              stroke="#99A1BB"
                                              stroke-linejoin="round"
                                            />
                                          </svg>
                                          <p>Share Only</p>
                                        </>
                                      )}
                                      {ele?.accessType == "PRIVATE" && (
                                        <>
                                          <svg
                                            className="private"
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="20"
                                            viewBox="0 0 16 20"
                                            fill="none"
                                          >
                                            <rect
                                              x="1"
                                              y="8"
                                              width="14"
                                              height="11.2"
                                              rx="1"
                                              stroke="#99A1BB"
                                              strokeWidth="1.5"
                                              stroke-linejoin="round"
                                            />
                                            <rect
                                              x="6.6875"
                                              y="12.375"
                                              width="2.275"
                                              height="2.275"
                                              rx="1.1375"
                                              stroke="#99A1BB"
                                              strokeWidth="1.5"
                                              stroke-linejoin="round"
                                            />
                                            <path
                                              d="M4.5 4.5C4.5 2.567 6.067 1 8 1V1C9.933 1 11.5 2.567 11.5 4.5V8H8H4.5V4.5Z"
                                              stroke="#99A1BB"
                                              strokeWidth="1.5"
                                              stroke-linejoin="round"
                                            />
                                          </svg>
                                          <p>Private</p>
                                        </>
                                      )}
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </Col>
                          </OverlayTrigger>
                        );
                      })}
                    </>
                  )}
                </>
              ) : (
                <div className="data-not-found-cmn ad-height-pop">
                  <p>No Data Found</p>
                </div>
              )}
            </Row>
          </div>
        </Modal.Body>
        {type !== "PlayBack" && (
          <Modal.Footer className="border-none justify-content-center pb-4">
            {type === "StudentDetail" && (
              <Button
                variant="primary"
                className="modal-f-btn"
                onClick={handleShare}
                disabled={loading ? true : false}
              >
                {loading ? "loading..." : "Share"}
              </Button>
            )}

            {type === "CollectionAddToTheClass" && (
              <Button
                variant="primary"
                className="modal-f-btn"
                onClick={handleShareCollectionWithClass}
                disabled={loading ? true : false}
              >
                {loading ? "loading..." : "Add"}
              </Button>
            )}
          </Modal.Footer>
        )}
      </Modal>

      <CreateCollectionModal
        showCollection={showCollection}
        handleCloseCollection={handleCloseCollection}
        value={value}
        setValue={setValue}
        type="CreateCollection"
        shortContainerRef={shortContainerRef}
      />

      <ConfirmModal
        data={null}
        isModalOpen={isModalOpen}
        selectedType={selectedType}
        handleConfirmClose={handleConfirmClose}
        extraFunction={
          type === "StudentDetail" ? sensitiveContentShare : sensitiveContentAdd
        }
      />
    </>
  );
};

export default SaveToCollection;
